export class Usuario {
  id: number;
  first_name: string;
  last_name: string;
  asignaciones: number;
}
/**
 * Modelamiento de la informacion del usuario en sesion
 * se utiliza cuando se lee la informacion enviada en el token
 *
 * @export
 * @class UsuarioActual
 */
export class UsuarioActual {
  info_persona: InformacionPersona;
  permisos?: Array<Permiso>;
  user_id: number;
  username: string;
  email: string;
}

/**
 * Estructura basica del token de autenticacion
 *
 * @export
 * @class UserToken
 */
export class UserToken {
  exp: number;
  username: string;
  orig_iat: number;
  user_data: string;
}

/**
 * Modelo del rol del usuario actual
 *
 * @export
 * @class UserRol
 */
export class UserRol {
  id_rol: number;
  rol: string;
  permisos: Array<any>;
}

/**
 * Modelo de la informacion del usuario actual
 *
 * @export
 * @class InformacionPersona
 */
export class InformacionPersona {
  apellidos: string;
  codigo_sede: number;
  empresa: string;
  id_empresa: number;
  id_sede: number;
  identificacion: string;
  nombres: string;
  sede: string;
}

/**
 * Modelo de consulta de las empresas
 *
 * @export
 * @class Empresa
 */
export class Empresa {
  id?: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de consulta de las empresas completo
 *
 * @export
 * @class Empresa
 */
export class EmpresaPredeterminada extends Empresa {
  web_page?: string;
  logo?: string;
  dias_laborales?: Array<number>;
  mensaje?: string;
}

/**
 * Modelo de la consulta de las sedes
 *
 * @export
 * @class Sede
 */
export class Sede {
  id?: number;
  nombre: string;
  descripcion: string;
  empresa: number;
}

/**
 * Modelo de la consulta de las sedes
 *
 * @export
 * @class SedeEmpresa
 */
export class SedeEmpresa extends Sede {
  codigo: number;
}

/**
 * Modelo de la consulta del smtp
 *
 * @export
 * @class EmailSmtp
 */
export class EmailSmtp {
  id?: number;
  empresa: number;
  host: string;
  port: number;
  username: string;
  password: string;
  use_tls?: boolean;
  fail_silently?: boolean;
}

/**
 * Modelo del permiso de el usuario en sesión
 *
 * @export
 * @class Permiso
 */
export class Permiso {
  id_permiso: number;
  permiso: string;
  acciones: Array<AccionPermisos>;
}

/**
 * Modelo de las acciones de el permiso de el usuario en sesión
 *
 * @export
 * @class AccionPermisos
 */
export class AccionPermisos {
  id: number;
  nombre: string;
}

/**
 * Modelo de un cargo del sistema
 *
 * @export
 * @class Cargo
 */
export class Cargo {
  id?: number;
  nombre: string;
  descripcion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/usuario.model.ts